import React from 'react';
import { Flex } from '@wegroup/design-system';
import { chakraCustomScrollBar } from '../../../../../../../common/src/utils/styledComponentsUtils';
import ScrollDownButtonContainer from '../scroll-button/ScrollDownButtonContainer';
import useHandleButtonScroll from '../../hooks/useHandleButtonScroll';
import { AdvisoryFlowMainContainerId } from './AdvisoryFlowMainContainer';

const AdvisoryFlowMainContainerContent: React.FC<
  React.PropsWithChildren<unknown>
> = ({ children, ...otherProps }) => {
  const { scrollContainer, isScrollable, setIsScrollable } =
    useHandleButtonScroll();

  return (
    <Flex
      id={AdvisoryFlowMainContainerId}
      flexDir="column"
      h="100%"
      position="relative"
      overflowY={{ base: 'unset', laptop: 'auto' }}
      sx={chakraCustomScrollBar}
      flexGrow={1}
      bg={{ base: 'gray.ultraLightBg', laptop: 'unset' }}
      {...otherProps}
    >
      {children}

      {/* Scroll button */}
      <ScrollDownButtonContainer
        scrollContainer={scrollContainer}
        isScrollable={isScrollable}
        setIsScrollable={setIsScrollable}
      />
    </Flex>
  );
};

export default AdvisoryFlowMainContainerContent;
